import { Box, Card, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as CaseManager } from '../../assets/icons/14-case-manager.svg';
import { ReactComponent as ProfileIcon } from '../../assets/icons/05-profile.svg';
import { sgrColors } from '../../ui/sgr/SgrColors';

const DailyControlHome = () => {
  const navigate = useNavigate();

  const sectionCardClass = {
    width: { xs: '100%', sm: '25rem' },
    maxWidth: '25rem',
    padding: '2rem',
    height: { xs: '14rem', sm: '25rem' },
    borderRadius: '6px',
    display: 'flex',
    justifyContent: 'center',
  };

  const alignedItems = {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    '&:hover, &.selected': {
      color: sgrColors.azure,
      transform: 'scale(1.2)',
    },
    transition: 'all 0.2s ease-in-out',
  };

  return (
    <Container>
      <Box
        sx={{
          padding: { xs: '1rem 0', md: '3.5rem' },
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          alignContent: 'center',
          justifyContent: 'center',
          gap: { xs: '1.5rem', md: '3rem' },
        }}
      >
        <Card sx={sectionCardClass}>
          <Box onClick={() => navigate('customers')} sx={alignedItems}>
            <CaseManager width={'6.5rem'} />
            <Typography variant="h3">Customers</Typography>
          </Box>
        </Card>
        <Card sx={sectionCardClass}>
          <Box onClick={() => navigate('users')} sx={alignedItems}>
            <ProfileIcon width={'6.5rem'} />
            <Typography variant="h3">Users</Typography>
          </Box>
        </Card>
      </Box>
    </Container>
  );
};

export default DailyControlHome;
